import React, { Component } from "react";
import {
    Badge,
    Button,
    FormControl,
    InputGroup,
    Dropdown
} from 'react-bootstrap';
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import PersonSharpIcon from '@material-ui/icons/PersonSharp';
import { getDate } from '../../../function';
import { PiArrowCounterClockwise, PiTrash } from "react-icons/pi";
import api from '../../../axios';
import apiError from '../../../error';
import { toast } from 'react-toastify';
import customSwal from "../../../customSwal";
import Loader from '../../../component/loader/loader';
import Pagination from "react-js-pagination";
export default class DeletedCampaign extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeId: null,
            deletedCampaigns: [],
            attackTypes: [],
            attackTypeId: '',
            search: '',
            loading: true,
            activePage: 1,
            limit: 10, // TODO: make this dynamic from the backend
            count: 0,
        }
    }

    loadAttackType = () => {
        api.get('/api/attacktypes', {})
            .then(res => {
                this.setState({ attackTypes: res.data.attackTypes });
            })
            .catch(err => apiError(err))
    }

    handleActiveCampaign = (campaignId) => {
        if (this.state.activeId === campaignId) {
            this.setState({ activeId: null })
        } else {
            this.setState({ activeId: campaignId })
        }
    }

    days_between = (date1, date2, Expired) => {
        const ONE_DAY = 1000 * 60 * 60 * 24;
        const differenceMs = Math.abs(date1 - date2);
        var day = differenceMs / ONE_DAY;
        day = day > 7 ? 100 : day * 100 / (Expired || 7);
        day = day > 100 ? 100 : day;
        if (day < 15) day = 15;
        return Math.floor(day);
    }

    compute_days = (date1, date2) => {
        const ONE_DAY = 1000 * 60 * 60 * 24;
        if (date1 < date2) return 0;
        const differenceMs = Math.abs(date1 - date2);
        return Math.ceil(differenceMs / ONE_DAY);
    }

    completion_percentage = (currDate, createdDate, expiryDate) => {
        const totalDays = this.compute_days(expiryDate, createdDate);
        const elapsedDays = Math.max(0, Math.min(this.compute_days(currDate, createdDate), totalDays));
        return totalDays > 0 ? Math.max(15, Math.round((elapsedDays / totalDays) * 100)) : 100;
    }

    load = async () => {
        try {
            this.setState({ loading: true });
            const response = await api.get('/api/campaigns', {
                params: {
                    deletedCampaign: true,
                    limit: this.state.limit,
                    page: this.state.activePage,
                    search: this.state.search,
                    attackTypeId: this.state.attackTypeId || '',
                }
            });
            this.setState(
                {
                    deletedCampaigns: response.data.campaigns,
                    count: response.data.count,
                    loading: false
                }
            );
        } catch (error) {
            this.setState({ deletedCampaigns: [], count: 0, loading: false });
            apiError(error);
        }
    }

    componentDidMount = () => {
        this.load();
        this.loadAttackType();
    }

    handleDeleteCampaign = (campaignId) => {
        customSwal({
            title: "Delete Permanently?",
            description: "This action  will permanently delete the campaign and cannot be undone. All associated analytics and any linked follow-up campaign will be permanently removed.",
            icon: "danger",
            buttons: ["No", "Yes"],
        }).then((willDelete) => {
            if (willDelete) {
                api.post(`/api/campaigns/hard-delete`, {
                    campaignIds: [campaignId]
                }).then((res) => {
                    toast.success(res.data.message);
                    this.load();
                }).catch((err) => {
                    apiError(err);
                });
            }
        });
    }

    handleRecoverCampaign = (campaignId) => {
        customSwal({
            title: " Recover Campaign?",
            description: "This action will recover the campaign and restore it to its original state. All associated analytics and any linked follow-up campaign will be restored.",
            icon: "success",
            buttonText: "Recover",
            buttons: ["No", "Yes"],
        }).then((willRecover) => {
            if (willRecover) {
                api.post(`/api/campaigns/recover`, {
                    campaignIds: [campaignId]
                }).then((res) => {
                    toast.success(res.data.message);
                    this.load();
                }).catch((err) => {
                    apiError(err);
                });
            }
        });
    }

    handlePage = (campaignId, simulationId) => {
        this.props.history.push(`/campaign/${campaignId}/${simulationId}?from=deleted-campaign`);
    }

    render() {

        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">
                                    <span
                                        href=""
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.props.history.push("/campaign");
                                        }}
                                        className="bar_Icons mr-2">
                                        <ArrowBackSharpIcon className="btn-icon" />
                                    </span>
                                    Deleted Campaigns
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contentbar campListGrids">
                    {/* filter wrapper */}
                    <div className="filter-without-border">
                        <div className="row align-items-center">
                            <div className="col-md-3">
                                <div className="positionSearchIcon">
                                    <InputGroup>
                                        <FormControl
                                            type="text"
                                            placeholder="Search"
                                            value={this.state.search}
                                            className="inputSearch mr-sm-2 form-control"
                                            onChange={(e) => this.setState({ search: e.target.value, activePage: 1 }, () => this.load())}
                                        />
                                        <SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="rightFilters">


                                    <Dropdown className="d-inline-block">
                                        <Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white">
                                            {this.state.limit}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {[10, 25, 50, 100].map((limit) => (
                                                <Dropdown.Item
                                                    key={`limit-${limit}`}
                                                    onClick={() => this.setState({ limit: limit, activePage: 1 }, () => this.load())}
                                                    active={this.state.limit === limit}
                                                >
                                                    {limit}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-content p-0">

                        <div className="table-container-wrapper">
                            <table className="table mx-0">
                                <thead>
                                    <tr>
                                        <th className="width-20">Deleted Campaign</th>
                                        <th>Deleted By</th>
                                        <th>Type</th>
                                        <th>Attack Vector</th>
                                        <th className="td-center">Days to Recover</th>
                                        <th className="td-center">Deletion Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.deletedCampaigns && this.state.deletedCampaigns.length > 0 ? this.state.deletedCampaigns.map((item, index) => (
                                        <tr key={`deleted-campaign-${item.id}`}>
                                            <td>
                                                {item.name}
                                                <p className="campaign-info">
                                                    {getDate(item.createdAt)} <span style={{ margin: '0px 5px' }}>•</span>
                                                    <PersonSharpIcon style={{ fontSize: '12px', marginLeft: '1px' }} /> {item.total}
                                                </p>
                                            </td>
                                            <td>
                                                <div style={{ fontSize: '12px', marginTop: '0px' }}>{item.deletedBy ?? ""}</div>
                                                <div style={{ fontSize: '10px', color: '#6c757d', marginTop: '4px' }}>
                                                    {getDate(item.deletedAt)}
                                                </div>
                                            </td>
                                            <td>
                                                <Badge variant="primary" className="badge-soft-purple">
                                                    {(() => {
                                                        // Simulation type comes from the simulation now, not the template.
                                                        const sim = item.simulations && item.simulations[0] ? item.simulations[0] : null;
                                                        return sim && sim.simulation_type ? sim.simulation_type.name : '---';
                                                    })()}
                                                </Badge>
                                            </td>
                                            <td>
                                                <Badge variant="primary" className="badge-soft-primary">{item.attack_type.name}</Badge>
                                            </td>
                                            <td className="td-center">
                                                {(() => {
                                                    if (!item.deletedAt) return '7 Days Left';
                                                    if (item.isHardDeleted) return '---';
                                                    const deletedDate = new Date(item.deletedAt);
                                                    const currentDate = new Date();
                                                    const diffTime = currentDate - deletedDate;
                                                    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                                                    const daysLeft = 7 - diffDays;
                                                    return daysLeft > 0 ? `${daysLeft} Days Left` : '0 Days Left';
                                                })()}
                                            </td>
                                            <td className="td-center">
                                                <div className="d-flex justify-content-center action-buttons" style={{ gap: '8px' }}>
                                                    {item.isHardDeleted ? (
                                                        <span style={{ color: 'red' }}>Deleted</span>
                                                    ) : item.evsDeletionStatus === "in_progress" ? (
                                                        <span style={{ color: 'green' }}>In Progress</span>
                                                    ) : (
                                                        <>
                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.handleRecoverCampaign(item.id);
                                                                }}
                                                                className="btn-action-secondary"
                                                            >
                                                                <PiArrowCounterClockwise />
                                                            </Button>

                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.handleDeleteCampaign(item.id);
                                                                }}
                                                                className="btn-action-danger"
                                                            >
                                                                <PiTrash />
                                                            </Button>
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )) : <tr><td colSpan="6" className="text-center">No deleted campaigns found</td></tr>}


                                </tbody>
                            </table>

                            {/* <div className="pagination-Wrap">
                                <div className="row">
                                    <div className="col-md-6">
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.count}
                                            onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
                                        />
                                    </div>
                                    <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                        <div className="w-100 pgCount">
                                            <p>{this.state.count === 0 ? 0 : this.state.activePage * this.state.limit + 1 - this.state.limit}-
                                                {this.state.activePage * this.state.limit > this.state.count ? this.state.count : this.state.activePage * this.state.limit} of {this.state.count} records</p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {this.state.deletedCampaigns && this.state.deletedCampaigns.length > 0 && (
                                <div className="pagination-Wrap">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Pagination
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={this.state.limit}
                                                totalItemsCount={this.state.count}
                                                onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.load())}
                                            />

                                        </div>
                                        <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                            <div className="w-100 pgCount">
                                                <p>{this.state.count === 0 ? 0 : this.state.activePage * this.state.limit + 1 - this.state.limit}-
                                                    {this.state.activePage * this.state.limit > this.state.count ? this.state.count : this.state.activePage * this.state.limit} of {this.state.count} records</p>
                                            </div>
                                        </div>
                                    </div>


                                    {this.state.loading && <Loader />}
                                </div>
                            )}
                        </div>

                    </div>


                </div>
            </div>
        );
    }
}